
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition de Display: Comprendre son Importance dans le Domaine Digital",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez tout ce que vous devez savoir sur le terme 'Définition display'. Donnez du sens à ce concept et enrichissez vos connaissances sur le sujet.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition de Display: Comprendre son Importance dans le Domaine Digital",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez tout ce que vous devez savoir sur le terme 'Définition display'. Donnez du sens à ce concept et enrichissez vos connaissances sur le sujet.",
        },
      ],
    };
  },
};
